/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { smartphoneBrokenDuocolor } from "../assets/smartphone-broken-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconSmartphoneBrokenDuocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={smartphoneBrokenDuocolor.svg} />
);

IllustrativeIconSmartphoneBrokenDuocolor.displayName = "IllustrativeIconSmartphoneBrokenDuocolor";
